
const getLevels = (value) => {
    const responseArray = []
    for (var i = 0; i < value.length; i += 2) {
        responseArray.push(
            parseInt(value.charAt(i).concat(value.charAt(i + 1)))
        )
    }
    return responseArray
}

const getSkillPoints = (value) => {
    return parseInt(value.substring(value.length - 65, value.length - 62))
}

const getCooldown = (value) => {
    return parseInt(value.substring(value.length - 67, value.length - 65)).toString()
}

const getThirdClassLevel = (value) => {
    return parseInt(value.substring(value.length - 69, value.length - 67)).toString()
}

const getCharLevel = (value) => {
    return parseInt(value.substring(value.length - 71, value.length - 69)).toString()
}

const getActualClass = (value) => {
    return value.substring(0, value.length - 71)
}

const buildSharedData = (data) => {
    const decodedData = atob(data)
    return {
        actualClass: getActualClass(decodedData),
        charLevel: getCharLevel(decodedData),
        thirdClassLevel: getThirdClassLevel(decodedData),
        cooldown: getCooldown(decodedData),
        skillPoints: getSkillPoints(decodedData),
        skillsLevels: getLevels(
            decodedData.substring(decodedData.length - 62, decodedData.length)
        ),
    }
}

export default buildSharedData
